global.ScrollTo = function(element) {
  element.click(function() {
    var div = element.data('div');
    $('html,body').animate({
       scrollTop: $(div).offset().top
    });
  });
};
